/**
 * LazyLoad setup
 * - Handles static and dynamically injected content (e.g. Einstein recommendations)
 */

var LazyLoad = require('vanilla-lazyload/dist/lazyload.min.js');

// Init LazyLoad for images
var lazyLoadInstance = new LazyLoad({
    unobserve_entered: true,
    cancel_on_exit: false,
    callback_enter: executeLazyFunction
});

// First scan of images in DOM
lazyLoadInstance.update();

// Watch for dynamic DOM updates (e.g. Einstein recommendations, AJAX content)
const observer = new MutationObserver(() => {
    lazyLoadInstance.update();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});

// Manual triggers (used by other components)
$('body').on('UpdateLoadImage', function() {
    lazyLoadInstance.update();
});

$('body').on('LoadSliderImages', function() {
    lazyLoadInstance.loadAll();
});

// Lazy functions registry
window.lazyFunctions = {
    UpdateSliderImageElement: function (element) {
        if (!$(element).closest('body').hasClass('sliderLoaded')) {
            $('body').trigger('LoadSliderImages');
            $(element).closest('body').addClass('sliderLoaded');
        }
    }
};

// Execute custom lazy function if defined in data-lazy-function
function executeLazyFunction(element) {
    var lazyFunctionName = element.getAttribute("data-lazy-function");
    var lazyFunction = window.lazyFunctions[lazyFunctionName];

    if (lazyFunction) lazyFunction(element);
}
